const creoToolkitCourse = {
    id: "creo-toolkit",
    name: "CREO Customization & Automation using Creo Toolkit",
syllabusPdf: "/syllabus/Creo-Syllabus-C++.pdf",

    hero: {
        title: "CREO Customization & Automation using Creo Toolkit",
        subtitle: "Live & Interactive Online Training",

        logo: "/creo-3.webp",

        points: [
            "Master Creo Toolkit customization to automate modeling, assemblies, and drawing generation directly within Creo Parametric.",

            "Ideal for mechanical engineers and CAD professionals who want to transition into high-demand roles with excellent salary and rapid career advancement through Creo automation.",

            "Learn to replace repetitive manual design tasks with powerful custom tools and workflows using the Creo Toolkit — the same toolkit used by top manufacturing and product development companies.",

            "We start from the basics of computer programming, so even beginners with no prior coding experience can excel.",

            "Get training and career guidance from the Industry Experts working in top tech companies."
        ]
    },

    highlights: [
        {
            title: "High Salary",
            description:
                "For CREO Engineers with 4 to 5 years of experience, the average CTC ranges from 5 Lakhs to 10 Lakhs. However, CREO Developers with the same experience can command CTCs of 20 Lakhs to 30 Lakhs."
        },
        {
            title: "Good Demand",
            description:
                "While CREO Design is a well-known skill among mechanical engineers, there is intense competition for design jobs. On the other hand, CREO Automation & Customization is a niche expertise, with only a few engineers."
        },
        {
            title: "Easier To Learn",
            description:
                "While CREO Design is generally easier to learn, CREO Automation & Customization can be more challenging. With our extensive experience in this field, we aim to simplify the process for you with our step by step training."
        }
    ],

    whyLearn: [
        {
            title: "Supercharge Your Productivity",
            description:
                "Automate repetitive modeling, assembly, and drawing tasks — complete in seconds what normally takes hours."
        },
        {
            title: "High-Demand Skill in Industry",
            description:
                "Companies are actively hiring professionals with Creo automation skills to reduce design cycle time and cost."
        },
        {
            title: "Higher Salary Opportunities",
            description:
                "Creo customizers and automation developers often earn significantly more than traditional design engineers."
        },
        {
            title: "Work Smarter, Not Harder",
            description:
                "Replace manual clicks with intelligent scripts and customized design workflows using Creo Toolkit."
        },
        {
            title: "Scale Design Projects Easily",
            description:
                "Generate hundreds of parts, assemblies, or drawings programmatically — ideal for product families and variants."
        },
        {
            title: "Build Your Own Design Tools",
            description:
                "Create custom UI panels, commands, features, and intelligent dialogs that integrate directly into Creo."
        },
        {
            title: "In-Demand Globally",
            description:
                "Automotive, aerospace, heavy machinery, and medical device industries worldwide use Creo and require automation experts."
        },
        {
            title: "Seamless Integration with Enterprise Systems",
            description:
                "Automate file handling, naming, configuration, and data exchange between Creo and PLM/ERP systems."
        },
        {
            title: "Career Shift into R&D and Tech Roles",
            description:
                "Move from routine drafting roles into advanced CAD engineering, R&D, and innovation-driven departments."
        },
        {
            title: "Gateway to Engineering Software Development",
            description:
                "Learning Creo Toolkit gives you a foundation in real-world engineering automation and software design."
        }
    ],

    syllabus: [
        {
            name: "C++",
            modules: [
                {
                    number: 1,
                    title: "Introduction to Visual Studio",
                    topics: [
                        "This module provides hands-on training in C++ programming using the Visual Studio IDE. It’s designed for beginners and intermediate learners who want to understand core programming concepts and build a strong foundation for software development, automation, and CAD customization."
                    ]
                },
                {
                    number: 2,
                    title: "Getting Started with Visual Studio",
                    topics: [
                        "Setting up and creating projects in Visual Studio IDE",
                        "Understanding the development environment",
                        "Background and evolution of C/C++"
                    ]
                },
                {
                    number: 3,
                    title: "C++ Programming Fundamentals",
                    topics: [
                        "Using Variables and Data Types",
                        "Types of Variables (Local, Global, Static, etc.)",
                        "Input and Output Streams (cin, cout)",
                        "Data Validation Techniques",
                        "Arithmetic & Assignment Operators",
                        "Logical & Bitwise Operators"
                    ]
                },
                {
                    number: 4,
                    title: "Control Flow & Logic Building",
                    topics: [
                        "Conditional Statements (if, else, switch)",
                        "Loops: for, while, do-while",
                        "Nested Loops",
                        "Arrays and Basic Data Structures"
                    ]
                },
                {
                    number: 5,
                    title: "Functions & Modularity",
                    topics: [
                        "Defining and Using Functions",
                        "Function Overloading",
                        "Passing Variables (by Value, by Reference)",
                        "References and Pointers",
                        "Dynamic Memory Allocation (new, delete)"
                    ]
                },
                {
                    number: 6,
                    title: "Object-Oriented Programming (OOP)",
                    topics: [
                        "Understanding Classes and Objects",
                        "OOP Principles: Encapsulation, Inheritance, Polymorphism",
                        "Templates (Function & Class Templates)",
                        "Creating and Managing Multiple .cpp and .h Files",
                        "Using Namespaces"
                    ]
                },
                {
                    number: 7,
                    title: "Advanced Concepts",
                    topics: [
                        "Runtime Polymorphism (Virtual Functions)",
                        "Inheritance Types",
                        "Exception Handling (try, catch, throw)",
                        "String Handling (std::string)",
                        "File Handling (Reading/Writing Files)"
                    ]
                },
                {
                    number: 8,
                    title: "Visual Studio Essentials",
                    topics: [
                        "Debugging Techniques",
                        "Breakpoints, Step-Through, Watch Windows",
                        "Organizing and Managing Multi-File Projects."
                    ]
                }
            ]
        },

        {
            name: "Creo Toolkit",
            modules: [
                {
                    number: 1,
                    title: "Introduction",
                    topics: [
                        "This hands-on training is designed to help engineers and CAD professionals master Creo Toolkit for automating and customizing design workflows inside PTC Creo Parametric. From UI customization to geometry manipulation, this course covers everything needed for real-world automation and integration."
                    ]
                },
                {
                    number: 2,
                    title: "Getting Started with Creo Customization",
                    topics: [
                        "Introduction to Creo Customization",
                        "How Creo links with Auxiliary Applications",
                        "Structure & Usage of the protk.dat File",
                        "Configuring Visual Studio with Creo Toolkit Libraries",
                        "Debugging Creo Applications in Visual Studio"
                    ]
                },
                {
                    number: 3,
                    title: "UI Customization & Interaction",
                    topics: [
                        "Adding Menus and Menu Buttons in Creo",
                        "Creating, Opening & Saving Creo Files Programmatically",
                        "Displaying Custom Messages to Users",
                        "Creating User Interface Dialogs",
                        "Interface and Event Notifications"
                    ]
                },
                {
                    number: 4,
                    title: "Model Exploration & Parameter Automation",
                    topics: [
                        "Visiting Components, Features, and Geometry",
                        "Evaluating and Measuring Geometry",
                        "Creating, Editing, and Deleting Model Parameters",
                        "Managing Units and Unit Conversions",
                        "Working with Mass Properties",
                        "Assigning Materials to Parts",
                        "Performing Coordinate Transformations"
                    ]
                },
                {
                    number: 5,
                    title: "Assembly Automation",
                    topics: [
                        "Assembling Components with Constraints",
                        "Working with Component Paths",
                        "Suppressing and Unsuppressing Components",
                        "Showing & Hiding Components",
                        "Setting and Controlling Views"
                    ]
                },
                {
                    number: 6,
                    title: "Data Import/Export",
                    topics: [
                        "Importing & Exporting Geometry (IGES, STEP, etc.)",
                        "Reading & Writing Data with Excel, XML, and Text Files"
                    ]
                },
                {
                    number: 7,
                    title: "Drawing Automation",
                    topics: [
                        "Creating, Editing & Deleting:\nViews\nDimensions\nNotes\nSheets\nTables",
                        "Working with Title Blocks & Drawing Attributes",
                        "Managing Drawing Parameters",
                        "Automating Bill of Materials (BOM)"
                    ]
                },
                {
                    number: 8,
                    title: "Feature Creation (Advanced)",
                    topics: [
                        "Overview of Custom Feature Creation",
                        "Creating Standard Features via Code"
                    ]
                }
            ]
        }
    ],

    videos: [
        {
            category: "CAD Customization & Automation",
            title: "CAD Customization And Automation Session",
            videoUrl:
                "https://www.youtube.com/embed/VpcpMwvQJy4?controls=1&rel=0&playsinline=0&cc_load_policy=0&autoplay=0&enablejsapi=1&origin=https%3A%2F%2Ffeesworth.com&widgetid=1&forigin=https%3A%2F%2Ffeesworth.com%2Fcreo-toolkit-customization-training%2F&aoriginsup=1&gporigin=https%3A%2F%2Ffeesworth.com%2Fpython-catia-automation-customization%2F&vf=1"
        },
        {
            category: "Sample Creo Toolkit customization",
            title: "Sample Creo Toolkit Automation & Customization",
            videoUrl:
                "https://www.youtube.com/embed/poccCwHW7ok?controls=1&rel=0&playsinline=0&cc_load_policy=0&autoplay=0&enablejsapi=1&origin=https%3A%2F%2Ffeesworth.com&widgetid=3&forigin=https%3A%2F%2Ffeesworth.com%2Fcreo-toolkit-customization-training%2F&aoriginsup=1&gporigin=https%3A%2F%2Ffeesworth.com%2Fpython-catia-automation-customization%2F&vf=1"
        },
        {
            category: "SOLIDWORKS API Sample Project",
            title: "NX Customization Training. NX Open API Training, CAD Customization Training. Sample Students Project",
            videoUrl:
                "https://www.youtube.com/embed/XXTr_xjRZto?controls=1&rel=0&playsinline=0&cc_load_policy=0&autoplay=0&enablejsapi=1&origin=https%3A%2F%2Ffeesworth.com&widgetid=5&forigin=https%3A%2F%2Ffeesworth.com%2Fcreo-toolkit-customization-training%2F&aoriginsup=1&gporigin=https%3A%2F%2Ffeesworth.com%2Fpython-catia-automation-customization%2F&vf=1"
        },
        {
            category: "SOLIDWORKS API Sample Project - Batch Export .prt to .igs & .stp",
            title: "NX Open API Programming - Batch Export to IGES & STEP",
            videoUrl:
                "https://www.youtube.com/embed/URpFRWwxFD0?controls=1&rel=0&playsinline=0&cc_load_policy=0&autoplay=0&enablejsapi=1&origin=https%3A%2F%2Ffeesworth.com&widgetid=7&forigin=https%3A%2F%2Ffeesworth.com%2Fcreo-toolkit-customization-training%2F&aoriginsup=1&gporigin=https%3A%2F%2Ffeesworth.com%2Fpython-catia-automation-customization%2F&vf=1"
        }
    ],

    faq: [
        {
            question: "What is Creo Customization?",
            answer:
                "Creo Customization refers to the process of customizing PTC’s Creo software, a comprehensive suite for computer-aided design (CAD), computer-aided engineering (CAE), and computer-aided manufacturing (CAM). This customization allows users to adapt Creo to their unique design and engineering needs, enhancing productivity and efficiency through tailored tools and workflows."
        },
        {
            question: "How Much Salary?",
            answer: [
                "CAA Developers often receive significantly higher salaries compared to CATIA 3D designers. This is because they create automation tools that can perform tasks that would be challenging for many individuals to accomplish without such tools.",

                "For a detailed explanation, please view the video located at this page."
            ]
        },
        {
            question: "I Have Creo Design Experience",
            answer: [
                "Absolutely, having CAD design experience is an advantage. It allows you to fully leverage your design skills and familiarity with CAD tools.",

                "You can adeptly assess and make informed decisions about which aspects to automate and the value that automation brings.",

                "In the future, your background can position you to lead teams of both design engineers and developers, bridging the gap between design excellence and cutting-edge automation solutions."
            ]
        },
        {
            question: "Job Guaranteed?",
            answer: [
                "Generally No.",
                "Sometimes Yes.",
                "Please speak to the coordinator for more details."
            ]
        },
        {
            question: "Which Programming Language?",
            answer:
                "For CATIA CAA Customization and Creo Toolkit Customization, C++ is an excellent choice"
        },
        {
            question: "Job Opportunities?",
            answer:
                "Creo Toolkit Customization, C++ is an excellent choice."
        }
    ]
};

export default creoToolkitCourse;